import React, { Component } from "react";
import Head from "next/head";
import getConfig from "next/config";

import CareersContainer from "@containers/Careers";
import ErrorPage from "@containers/ErrorPage";
import { getCareers } from "@store/careers/actions";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

class CareersPage extends Component {
  static async getInitialProps(ctx) {
    const { reduxStore } = ctx;

    const departmentsWithJobPositions = await reduxStore.dispatch(getCareers());

    return {
      departmentsWithJobPositions,
    };
  }

  render() {
    const { departmentsWithJobPositions } = this.props;

    if (departmentsWithJobPositions) {
      return (
        <>
          <Head>
            <title>{`Cariere - Locuri de munca ${websiteTitle}`}</title>

            <meta
              name="description"
              content={`Dezvolta-ti cariera cu ${websiteTitle}! Urmareste pozitiile vacante, afla noutatile si vino la interviu! Devino parte din echipa si beneficiezi de un pachet salarial atractiv, de invatare continua si de colegi pe masura! Hai sa descoperim impreuna cum putem creste!`}
            ></meta>

            <meta
              name="keywords"
              content="locuri de munca, dezvoltare cariera, job-uri, joburi, pozitii vacante, oportunitati cariera"
            ></meta>
          </Head>

          <CareersContainer
            departmentsWithJobPositions={departmentsWithJobPositions}
          />
        </>
      );
    }

    return (
      <ErrorPage>{`Pagina de cariere este momentan indisponibila.`}</ErrorPage>
    );
  }
}

CareersPage.pageLayout = "default";

export default CareersPage;
